import { Row as AntdRow } from "antd";
import { defaultProps, RowProps } from "./Row.type";
import styles from "./Row.module.scss";

export const Row = (props: RowProps) => {
	const { children, ...attributes } = { ...defaultProps, ...props }

	return (
		<AntdRow {...attributes} className={styles.Row}>
			{children}
		</AntdRow>
	);
};
